"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsModule = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const store_1 = require("client/modules/users/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const app_settings_assets_1 = require("./tabs/app-settings-assets/");
const app_settings_billing_1 = require("./tabs/app-settings-billing/");
const app_settings_developer_1 = require("./tabs/app-settings-developer/");
const app_settings_cancellation_1 = require("./tabs/app-settings-cancellation/");
const app_settings_general_1 = require("./tabs/app-settings-general/");
const app_settings_insurance_1 = require("./tabs/app-settings-insurance/");
const app_settings_rejections_1 = require("./tabs/app-settings-rejections/");
const app_settings_distributor_1 = require("./tabs/app-settings-distributor");
const app_settings_claim_data_1 = require("./tabs/app-settings-claim-data");
const app_settings_stuck_claims_1 = require("./tabs/app-settings-stuck-claims/");
let AppSettingsModule = class AppSettingsModule extends router_1.TabRouter {
    constructor(props) {
        super(props);
        this.addTab("General", `/settings`, /^\/(app-)?settings\/?$/, () => (React.createElement(app_settings_general_1.AppSettingsGeneral, null)));
        this.addTab("Insurance", `/settings/insurance`, /^\/(app-)?settings\/insurance\/?$/, () => React.createElement(app_settings_insurance_1.AppSettingsInsurance, null));
        this.addTab("Rejections", `/settings/rejections`, /^\/(app-)?settings\/rejections\/?$/, () => React.createElement(app_settings_rejections_1.AppSettingsRejections, null));
        this.addTab("Cancellations", `/settings/cancellations`, /^\/(app-)?settings\/cancellations\/?$/, () => React.createElement(app_settings_cancellation_1.AppSettingsCancellation, null));
        this.addTab("Assets", `/settings/assets`, /^\/(app-)?settings\/assets\/?$/, () => React.createElement(app_settings_assets_1.AppSettingsAssets, null));
        this.addTab("Billing", `/settings/billing`, /^\/(app-)?settings\/billing\/?$/, () => React.createElement(app_settings_billing_1.AppSettingsBilling, null));
        this.addTab("Distributor", `/settings/distributor`, /^\/(app-)?settings\/distributor\/?$/, () => React.createElement(app_settings_distributor_1.AppSettingsDistributor, null));
        this.addTab("Claim Data", `/settings/claim-data`, /^\/(app-)?settings\/claim-data\/?$/, () => React.createElement(app_settings_claim_data_1.AppSettingsClaimData, null));
        // this.addTab("User Permissions", `/settings/user`, /^\/(app-)?settings\/user\/?$/, () => <AppSettingsGeneral />);
        if (store_1.usersStore.user.value.groupId === 4) {
            this.addTab("Developer", `/settings/dev`, /^\/(app-)?settings\/dev(eloper)?\/?$/, () => React.createElement(app_settings_developer_1.AppSettingsDeveloper, null));
        }
        //E-096 B-049.611
        if (store_1.usersStore.user.value.groupId === 4) {
            this.addTab("Stuck Claims", `/settings/stuck-claims`, /^\/(app-)?settings\/stuck-claims\/?$/, () => React.createElement(app_settings_stuck_claims_1.AppSettingsStuckClaims, null));
        }
    }
    render() {
        this.withPadding = true;
        return (React.createElement("div", { className: "inventory-detail" }, store_1.usersStore.permissions.ReadSettings ? (React.createElement(React.Fragment, null,
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement(kpi_title_1.KpiTitle, { label: "Settings" })),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "inventory-detail__tabs" }, super.render())))) : (store_1.usersStore.showLock())));
    }
};
AppSettingsModule = __decorate([
    mobx_react_1.observer
], AppSettingsModule);
exports.AppSettingsModule = AppSettingsModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/app-settings.tsx
// module id = 3167
// module chunks = 0